<div class="dropdown-etoll">
    <ng-container *ngIf="isETollRegistered">
        <div class="dropdown-etoll__header">
            <span class="title">
              {{ 'etoll-panel.acc-etoll' | translate }}
            </span>
            <span class="description">
              {{ 'etoll-panel.prepaid-only' | translate }}
            </span>
          </div>
          <div class="dropdown-etoll__list">
            <div *ngFor="let item of list" class="dropdown-etoll__list__item">
              <div class="dropdown-etoll__list__item__header">
                <p-radioButton 
                  [value]="item.IdETollBalance"
                  [(ngModel)]="etollSelectedBalance"
                  (ngModelChange)="onChangeSelectedBalance($event)"
                  [pTooltip]="'pinOnBelt'|translate"
                  tooltipPosition="top"
                  tooltipStyleClass="tooltip-pinned"
                  name="pizza"
                  size="large"
              ></p-radioButton>
                <div class="title">{{ item.Balance | currency : 'PLN' : 'symbol-narrow' }}</div>
              </div>
              <div class="dropdown-etoll__list__item__details">
                <span>{{ 'etoll-panel.account-number' | translate }} {{ item.IdETollBalance }}</span>
                <span>{{ 'etoll-panel.account-for-date' | translate }} {{ item.BalanceDate | date : 'dd.LL.yyyy HH:mm' }}</span>
              </div>
            </div>
        </div>
    </ng-container>
    <app-activate-etoll *ngIf="!isETollRegistered"></app-activate-etoll>
</div>
